import * as React from 'react';
import { CSSProperties } from 'react';
import * as Tgcc from '../tgccGlobal';

type FilterProperties = {
    groupName: string;
    groupLabel: string;
    expanded: boolean;
    filters: Map<string, any>;
    state: Array<any>;
    counts: Map<string, number>;
    setFilter: (value: any, checked: boolean) => void;
    clearAll: () => void;
}

const groupStyle: CSSProperties = {
    fontSize: '10px',
    textTransform: 'uppercase',
    letterSpacing: '3px',
    textAlign: 'left',
    padding: '10px 20px',
    position: 'relative',
    width: '240px',
};
const groupNameStyle: CSSProperties = {
    display: 'block',
    float: 'left',
    fontWeight: 'bold',
    fontSize: '15px',
    marginBottom: '2px',
    lineHeight: '16px',
    fontFamily:'Lulo',
    letterSpacing:'0px'

};
const groupExpanderStyle: CSSProperties = {
    fontSize: '12px',
    display: 'block',
    float: 'right',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer'
};
const contentStyle: CSSProperties = {
    float: 'left',
    clear: 'both',
    display: 'flex',
    flexDirection: 'column',
    lineHeight: '14px',
    letterSpacing: 0
}
const hiddenStyle: CSSProperties = {
    display: 'none',
}
const checkStyle: CSSProperties = {
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    verticalAlign: 'center',
    fontSize: '13px',
    height: '22px'
}
const checkboxStyle: CSSProperties = {
    marginRight: '6px',
    marginTop: '4px'
}
const bubbleStyle: CSSProperties = {
    marginLeft: '4px',
    textTransform: 'none',
    letterSpacing: 0,
    float: 'left',
    display: 'block',
    backgroundColor: '#58585A',
    color: 'white',
    borderRadius: '8px',
    lineHeight: '12px',
    fontSize: '10px',
    padding: '2px 7px'
}
const clearStyle: CSSProperties = {
    float: 'right',
    fontSize: '16px',
    marginLeft: '7px',
    cursor: 'pointer'
}

type StateType = { expanded: boolean }

export class FilterGroup extends React.Component<FilterProperties, any> {

    state: StateType = { expanded: this.props.expanded }

    itemStyle: CSSProperties = {
        fontSize: '8px'
    };

    getItemName(value: string) {
        var prefix: string = this.props.groupName + '_';
        return prefix + value;
    }

    getFilterElements() {
        var elements = new Array();
        var checkedState = this.props.state;
        this.props.filters.forEach((value, key) => {
            var itemName: string = this.getItemName(value);
            var checked: boolean = checkedState ? (checkedState.indexOf(value) > -1) : false;
            var keyName: string = itemName + '_div';
            var count: number = this.props.counts ? this.props.counts[value] : null;
            var label: string = key;
            if(count){
                label += " ("+ count +")";
            }
            elements.push(<div key={keyName} style={checkStyle}><input key={itemName} name={this.props.groupName} checked={checked} id={itemName} type="checkbox" style={checkboxStyle} value={value} onChange={(evt: any) => this.props.setFilter(value, evt.currentTarget.checked)} /> {label}<br /></div>);
        });
        return elements;
    }

    toggle(grp: FilterGroup) {
        grp.setState({ expanded: !this.state.expanded });
    }

    getSelectedBubble() {
        var ct: number = this.props.state ? this.props.state.length : 0
        if (ct > 0)
            return <div style={bubbleStyle}>{ct} selected<div onClick={() => this.props.clearAll()} style={clearStyle}>&times;</div></div>
        return <div />
    }

    render() {
        var selectedBubble = this.getSelectedBubble();
        var items = this.getFilterElements();
        var expander = this.state.expanded
            ? (<div style={groupExpanderStyle} checked={false} onClick={() => this.toggle(this)}>&mdash;</div>)    // minus
            : (<div style={groupExpanderStyle} checked={false} onClick={() => this.toggle(this)}>&#x2795;</div>);  // plus

        var collapsibleSectionStyle = this.state.expanded ? contentStyle : hiddenStyle;
        var key: string = this.props.groupName + '_div';
        return (
            <div key={key} style={groupStyle}>
                <div style={groupNameStyle} onClick={() => this.toggle(this)}>{this.props.groupLabel}</div>
                {selectedBubble}
                {expander}
                <div style={collapsibleSectionStyle}>{items}</div>
            </div>
        )
    }
}
